module.exports = __webpack_public_path__ + "static/social2-116aa5055cf357354ae482b8812c38e3.jpg";